<sc-padding leftRightOnly fitHeight>
  <sc-flex vertical [gap]="16" stretchContent fitHeight>
    <sc-flex-fitting-content vertical>
      <sc-scroll-pane>
        @for (schedule of transportOption.limitSchedules; track schedule) {
        <app-transport-option-editor-limits-schedule [schedule]="schedule"
          (removeRequested)="removeLimitSchedule($event)"></app-transport-option-editor-limits-schedule>
        }
      </sc-scroll-pane>
    </sc-flex-fitting-content>
    <sc-flex centered>
      <sc-add-action-button large (click)="addLimitSchedule()"></sc-add-action-button>
    </sc-flex>
  </sc-flex>
</sc-padding>
